import React from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import {
  renderselect,
  renderTextField
} from "../../../../Components/Forms/renders";
class SportenSpelform extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {}
    };
  }

  render() {
    const { handleSubmit } = this.props;
    if (this.props.loaded) {
      return (
        <div className="box box-default">
          <form onSubmit={handleSubmit}>
            <div className="box-body">
              <div className="row">
                <div className="col-12">
                  <Field
                    className="form"
                    name="sportenspel.sportenspel"
                    label="Algemeen"
                    component={renderselect}
                    options={{
                      onvoldoende: "onvoldoende",
                      voldoende: "voldoende",
                      redelijk: "redelijk",
                      goed: "goed"
                    }}
                  />
                  <Field
                    className="form"
                    name="sportenspel.voorbereid"
                    label="Voorbereid"
                    component={renderselect}
                    options={{
                      ja: "ja",
                      nee: "nee"
                    }}
                  />

                  <Field
                    className="form"
                    name="sportenspel.handelen"
                    label="Creëert een situatie waaruit gehandeld kan worden"
                    component={renderselect}
                    options={{
                      matig: "matig",
                      voldoende: "voldoende",
                      ruimvoldoende: "ruim voldoende",
                      goed: "goed",
                      uitstekend: "uitstekend"
                    }}
                  />
                  <Field
                    className="form"
                    name="sportenspel.spelbedoeling"
                    label="Geeft spelbedoeling aan"
                    component={renderselect}
                    options={{
                      matig: "matig",
                      voldoende: "voldoende",
                      ruimvoldoende: "ruim voldoende",
                      goed: "goed",
                      uitstekend: "uitstekend"
                    }}
                  />
                  <Field
                    className="form"
                    name="sportenspel.praatjeplaatje"
                    label="Praatje-plaatje-daadje"
                    component={renderselect}
                    options={{
                      matig: "matig",
                      voldoende: "voldoende",
                      ruimvoldoende: "ruim voldoende",
                      goed: "goed",
                      uitstekend: "uitstekend"
                    }}
                  />
                  <Field
                    className="form"
                    name="sportenspel.enthousiast"
                    label="Enthousiasme tijdens spel (bijv. Moedigt aan,
                    juiste positie, geeft complimenten,
                    helpt waar nodig)"
                    component={renderselect}
                    options={{
                      matig: "matig",
                      voldoende: "voldoende",
                      ruimvoldoende: "ruim voldoende",
                      goed: "goed",
                      uitstekend: "uitstekend"
                    }}
                  />
                  <Field
                    className="form"
                    name="sportenspel.onderbreking"
                    label="Onderbreking (positieve feedback, past aan,
                    geeft variatie)"
                    component={renderselect}
                    options={{
                      matig: "matig",
                      voldoende: "voldoende",
                      ruimvoldoende: "ruim voldoende",
                      goed: "goed",
                      uitstekend: "uitstekend"
                    }}
                  />
                  <Field
                    className="form"
                    name="sportenspel.afsluiting"
                    label="Afsluiting (positieve feedback, promotie)"
                    component={renderselect}
                    options={{
                      matig: "matig",
                      voldoende: "voldoende",
                      ruimvoldoende: "ruim voldoende",
                      goed: "goed",
                      uitstekend: "uitstekend"
                    }}
                  />
                  <Field
                    className="form"
                    name="sportenspel.voordegroep"
                    label="Staat zeker voor de groep"
                    component={renderselect}
                    options={{
                      matig: "matig",
                      voldoende: "voldoende",
                      ruimvoldoende: "ruim voldoende",
                      goed: "goed",
                      uitstekend: "uitstekend"
                    }}
                  />
                  <Field
                    className="form"
                    name="sportenspel.opmerkingen"
                    label="Overige Opmerkingen"
                    component={renderTextField}
                  />
                </div>
              </div>
              <div className="pull-left submit">
                <input
                  type="submit"
                  className="btn btn-next btn-fill btn-success btn-wd btn-mg"
                  name="next"
                  value="Beoordelen"
                />
              </div>
            </div>
          </form>
        </div>
      );
    } else {
      return null;
    }
  }
}
SportenSpelform = reduxForm({
  form: "beoordelingsportenspel", // a unique identifier for this form
  enableReinitialize: true
})(SportenSpelform);

// You have to connect() to any reducers that you wish to connect to yourself
SportenSpelform = connect(
  state => ({
    initialValues: state.beoordelingen.item // pull initial values from account reducer
  }),
  {}
)(SportenSpelform);

export default SportenSpelform;
